import type { AudioAnnotationToggleField } from '@/features/nectar/api/models'
import { type MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react/macro'
import { clsx } from 'clsx'
import { FieldLabel } from '../FieldLabel'

type ToggleFieldProps = {
  field: AudioAnnotationToggleField
  value: boolean | undefined
  onChange: (value: boolean) => void
}

const OPTIONS: { label: MessageDescriptor; value: boolean }[] = [
  { label: msg`Yes`, value: true },
  { label: msg`No`, value: false }
]

export const ToggleField = ({ field, value, onChange }: ToggleFieldProps) => {
  const { t } = useLingui()

  return (
    <div className="flex flex-col gap-3">
      <FieldLabel label={field.label} description={field.description} required={field.required} />
      <div className="flex gap-2">
        {OPTIONS.map((option) => {
          const selected = value === option.value
          return (
            <button
              key={String(option.value)}
              type="button"
              onClick={() => onChange(option.value)}
              className={clsx(
                'flex h-10 min-w-[80px] flex-1 cursor-pointer items-center justify-center rounded-lg border border-solid px-4 font-semibold transition-colors',
                selected ? 'border-green bg-green/5 text-green' : 'text-gray-70 hover:border-gray-90 border-gray-100'
              )}
            >
              {t(option.label)}
            </button>
          )
        })}
      </div>
    </div>
  )
}
